import React from "react";

function BankDetails() {
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert(`Copied: ${text}`);
  };

  const details = [
    {
      label: "Account Holder Name",
      value: "AJATUS SOFTWARE PVT LTD",
      iconBg: "bg-blue-100",
      iconColor: "text-blue-600",
      iconPath:
        "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z",
    },
    {
      label: "Account Number",
      value: "50200096248240",
      iconBg: "bg-indigo-100",
      iconColor: "text-indigo-600",
      iconPath:
        "M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2",
      copy: true,
    },
    {
      label: "IFSC Code",
      value: "HDFC0004491",
      iconBg: "bg-green-100",
      iconColor: "text-green-600",
      iconPath:
        "M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5",
      copy: true,
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-3xl shadow-2xl border border-gray-100 overflow-hidden">

          {/* HEADER */}
          <div className="bg-gradient-to-r from-red-600 to-red-700 text-white p-5 flex items-center gap-4">
            <div className="bg-white/20 p-3 rounded-2xl">
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 10h18M7 15h10m-9 4h8a2 2 0 002-2V7a2 2 0 00-2-2H8a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
            </div>
            <div>
              <h1 className="text-xl font-bold tracking-wide" style={{marginLeft:"130px"}}>HDFC Bank</h1>
              <p className="text-red-100 text-xs " style={{marginLeft:"130px"}}>Bank Account Details</p>
            </div>
          </div>

          {/* ACCOUNT HOLDER STRIP */}
          {/* <div className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-4 py-2">
            <div className="flex items-center gap-3">
              <div className="bg-white/20 p-2 rounded-xl">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h-4m-8 0H5"
                  />
                </svg>
              </div>
              <div>
                <p className="text-[11px] opacity-80">Account Holder</p>
                <p className="text-sm font-semibold tracking-wide">AJATUS SOFTWARE PVT LTD</p>
              </div>
            </div>
          </div> */}

          {/* DETAILS (GAP REDUCED HERE) */}
          <div className="p-3 space-y-2">
            {details.map((item, index) => (
              <div
                key={index}
                className="group bg-white rounded-xl p-3 border border-gray-200 shadow-sm hover:shadow transition flex items-center justify-between"
              >
                <div className="flex gap-4">
                  <div className={`${item.iconBg} p-2.5 rounded-xl`}>
                    <svg
                      className={`w-5 h-5 ${item.iconColor}`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d={item.iconPath}
                      />
                    </svg>
                  </div>

                  <div>
                    <p className="text-[11px] text-gray-500 font-medium">{item.label}</p>
                    <p className="font-semibold text-gray-900 text-sm tracking-wide font-mono">
                      {item.value}
                    </p>
                  </div>
                </div>

                {item.copy && (
                  <button
                    onClick={() => copyToClipboard(item.value)}
                    className="opacity-0 group-hover:opacity-100 bg-indigo-600 hover:bg-indigo-700 text-white text-xs px-3 py-1.5 rounded transition shadow-sm"
                  >
                    Copy
                  </button>
                )}
              </div>
            ))}

            {/* BRANCH */}
            <div className="bg-white rounded-xl p-3 border border-gray-200 shadow-sm flex items-center gap-4">
              <div className="bg-orange-100 p-2.5 rounded-xl">
                <svg className="w-5 h-5 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
              </div>

              <div>
                <p className="text-[11px] text-gray-500 font-medium">Branch</p>
                <p className="font-semibold text-gray-900 text-sm tracking-wide">
                  Jaydev Vihar, Bhubaneswar
                </p>
              </div>
            </div>
          </div>

          {/* FOOTER */}
          <div className="bg-gray-50 px-4 py-3 text-center border-t text-[11px] text-gray-500">
            Please verify details before making a transaction.
          </div>

          <p className="text-center py-2 text-[11px] text-gray-400">
            © AJATUS SOFTWARE PVT LTD
          </p>
        </div>
      </div>
    </div>
  );
}

export default BankDetails;
